import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DateTime } from 'luxon';
import { formatAbn } from '../lib/formatter';

const useStyles = makeStyles((theme) => ({
  footer: {
    width: '100%',
    color: theme.palette.grey[900],
    textAlign: 'center',
    padding: theme.spacing(2),
    fontSize: 11,
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    '& a:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.up('xs')]: {
      color: theme.palette.grey[900],
      '& a': {
        textDecoration: 'none',
        color: theme.palette.grey[900],
      },
      '& a:hover': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      &copy; Copyright {DateTime.now().toFormat('yyyy')}.&nbsp;
      <a href='https://www.shift.com.au/' target='_blank' rel='noopener noreferrer'>
        Shift Financial
      </a>
      &nbsp;ABN:{' '}
      <a href='https://abr.business.gov.au/ABN/View?id=24149390625' target='_blank' rel='noopener noreferrer'>
        {formatAbn('24149390625')}
      </a>
    </footer>
  );
};

export default Footer;
